'use client';

import { type ReactElement } from 'react';
import { CurrencyDisplay } from './currency-display';
import { StoresMenu } from './stores-menu';
import { AccountMenu } from './account-menu';
import { NdulgeLink } from './ndulge-link';
import { WishlistIcon } from './wishlist-icon';
import { CartBadge } from './cart-badge';

/**
 * The header "user menu" — the row of links right of the search form: currency, stores, account, NDULGE,
 * wishlist, cart. On mobile only the account icon and cart stay; the row hides the rest with
 * `hidden lg:flex`. Hiding lives here, not in the components, so the burger menu can reuse them visible.
 */
export const UserActions = (): ReactElement => (
    <div className="flex items-center gap-4 lg:gap-6">
        <CurrencyDisplay className="hidden lg:flex" />
        <StoresMenu className="hidden lg:flex" />
        <AccountMenu />
        <NdulgeLink className="hidden lg:flex" />
        <WishlistIcon className="hidden lg:flex" />
        <CartBadge />
    </div>
);
